import React, { useState } from "react";
import { styled } from "baseui";
import { Button, SIZE, SHAPE, KIND } from "baseui/button";
import { ListItem, ListItemLabel, ARTWORK_SIZES } from "baseui/list";
import { HeadingSmall, LabelMedium, LabelSmall } from "baseui/typography";
import { FaTimes } from "react-icons/fa";
import { StatefulSelect } from "baseui/select";

const Container = styled("div", {
    display: "flex",
    flexDirection: "column",
    gap: "24px",
    height: "100%",
    width: "900px",
    margin: "120px auto",
//   alignContent: "right",
  });

const TitleContainer = styled("div", {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",

});

const ListContainer = styled("div", {
  overflowY: "auto",
});
const UserRoleSelect = styled(StatefulSelect, {
  width: "150px",
  marginRight: "24px", // Add some space between the dropdown and the button
});
const MemberContainer = styled("div", {
  display: "flex",
  gap: "24px",
  width: "250px",
  alignItems: "center",
//   justifyContent: "space-between", // Add this line
});

const UserAccountMembersView = () => {
  const [members, setMembers] = useState([
    {
      id: 1,
      name: "John Doe",
      email: "john@example.com",
      role: "Admin",
    },
    {
      id: 2,
      name: "Jane Smith",
      email: "jane@example.com",
      role: "Regular",
    },
  ]);

  const changeUserRole = (userId, newRole) => {
    setMembers(
      members.map((member) =>
        member.id === userId ? { ...member, role: newRole } : member
      )
    );
  };

  return (
    <Container>
      <TitleContainer>
        <HeadingSmall>Members</HeadingSmall>
        <Button size={SIZE.compact} shape={SHAPE.pill} kind={KIND.secondary}>
          Invite members
        </Button>
      </TitleContainer>
      <ListContainer>
        <ul>
          {members.map((member) => (
            <ListItem
              key={member.id}
              artworkSize={ARTWORK_SIZES.LARGE}
              endEnhancer={() => (
                <MemberContainer>
                  <UserRoleSelect
                  size={SIZE.mini}
                    options={[
                      { id: "Owner", label: "Owner" },
                      { id: "Admin", label: "Admin" },
                      { id: "Regular", label: "Regular" },
                    ]}
                    onChange={({ value }) =>
                      changeUserRole(member.id, value[0].id)
                    }
                    clearable={false}
                    searchable={false}
                    value={[{ id: member.role, label: member.role }]}
                  />
                  <Button
                    size={SIZE.mini}
                    kind={KIND.secondary}
                    shape={SHAPE.pill}
                    startEnhancer={<FaTimes />}
                    overrides={{
                      BaseButton: {
                        style: ({ $theme }) => ({
                          backgroundColor: $theme.colors.negative,
                          color: $theme.colors.white,
                        }),
                      },
                    }}
                  >
                    Leave
                  </Button>
                </MemberContainer>
              )}
            >
              <ListItemLabel>
                <LabelMedium>{member.name}</LabelMedium>
                <LabelMedium>{member.email}</LabelMedium>
              </ListItemLabel>
            </ListItem>
          ))}
        </ul>
      </ListContainer>
    </Container>
  );
};

export default UserAccountMembersView;
